export default __webpack_public_path__ + "static/gmail-3a59d3ee10cbb4f4812978dba2e2f098.svg";